<div [formGroup]="formGroup">

  <!-- Name / Enabled -->
  <div class="row">

    <div class="col-sm-6">
      <div class="form-group">
        <label title="Name the monitor item after its purpose">Name</label>
        <input type="text" class="form-control" formControlName="name" />
        @if (showError('name', 'required')) {
          <p class="error">Required</p>
        }
      </div>
    </div>

    <div class="col-sm-6">
      <div class="form-group">
        <div class="control control-checkbox lg control-form-group">
          <label>
            Enabled
            <input type="checkbox" formControlName="enabled" />
            <i></i>
          </label>
        </div>
      </div>
    </div>

  </div> <!-- End row -->

  <!-- Group / Stakeholder -->
  <div class="row">

    <div class="col-sm-6">
      <div class="form-group">
        <label>Group</label>
        <select class="form-control" formControlName="groupId">
          <option [ngValue]="0" disabled>Select...</option>
          @for (item of monitorGroups; track item) {
            <option [ngValue]="item.id">{{ item.name }}</option>
          }
        </select>
        @if (showError('groupId', 'min')) {
          <p class="error">Required</p>
        }
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-group">
        <label>Stakeholder</label>
        <select class="form-control" formControlName="stakeholderId">
          <option [ngValue]="0">None</option>
          @for (item of stakeholders; track item) {
            <option [ngValue]="item.StakeholdersId">{{ item.Name }}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="col-sm-3">
      @if (isStakeholderSelected) {
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <div class="control control-checkbox lg control-form-group">
                <label>
                  Urgent
                  <input type="checkbox" formControlName="stakeholderUrgent" />
                  <i></i>
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="control control-checkbox lg control-form-group">
                <label>
                  Continous notifications
                  <input type="checkbox" formControlName="stakeholderContinuous" />
                  <i></i>
                </label>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

  </div> <!-- End row -->

  <!-- Pollint interval / Description -->
  <div class="row">

    <div class="col-sm-6">
      <div class="form-group">
        <label title="Specify how often this monitor item must execute">Polling interval</label>
        <ep-duration-picker innerClass="form-control" formControlName="pollingInterval" [invalid]="pollingIntervalIsInvalid"></ep-duration-picker>
        @if (showError('pollingInterval', 'min')) {
          <p class="error">Out of range</p>
        }
        @if (showError('pollingInterval', 'required')) {
          <p class="error">Required</p>
        }
      </div>
    </div>

    <div class="col-sm-6">
      <div class="form-group">
        <label title="Describe the purpose of this monitor item">Description</label>
        <textarea class="form-control fit-column" formControlName="description"></textarea>
      </div>
    </div>

  </div> <!-- End row -->

  <!-- Suppress To / Times -->
  <div class="row">

    <div class="col-sm-6">
      <div class="form-group">
        <label
          title="Suppress errors to this status as many times as specified in the next field; after this number of times suppressiong is temporarily disabled">
          Suppress Error(s) to status
        </label>
        <select class="form-control" formControlName="suppressTo">
          @for (item of suppressToStatuses; track item) {
            <option [ngValue]="item.id">{{ item.name }}</option>
          }
        </select>
      </div>

    </div>

    <div class="col-sm-6">
      @if (isSuppressTimesVisible) {
        <div class="form-group">
          <label
            title="Specify how many times to suppress errors; after this numer of times, suppressing is temporarily disabled until another check is executed with success">
            Suppress number of times
          </label>
          <input type="number" min="1" class="form-control" formControlName="suppressTimes" />
          @if (showError('suppressTimes', 'min')) {
            <p class="error">Out of range</p>
          }
          @if (showError('suppressTimes', 'required')) {
            <p class="error">Required</p>
          }
        </div>
      }
    </div>

  </div> <!-- End row -->

  <!-- Artifact / Schedule -->
  <div class="row">

    <div class="col-sm-6">
      @if (!isEmbeddedMonitorItem) {
        <div class="form-group">
          <label title="Specify what kind of monitor type that should be configured for this monitor item">Type</label>
          <app-developer-artifact-assembly-picker [assemblyTypes]="['MonitorType']" [isReadOnly]="formGroupDisabled"
            [(selectedArtifactId)]="selectedArtifactId">
          </app-developer-artifact-assembly-picker>
        </div>
      }
      <ep-datafield-group-container #dfgContainer [formValidationGroup]="artifactConfigValidationGroup"
        [showError]="true" [datafieldGroups]="artifactDfgs" [isAlwaysEditable]="formGroup.enabled" [numberOfColumns]="2">
      </ep-datafield-group-container>
    </div>

    <div class="col-sm-6">
      <div class="form-group">
        <label>Schedule</label>
        <select class="form-control" formControlName="scheduleId">
          <option [ngValue]="0">24/7/365</option>
          @for (item of monitorSchedules; track item) {
            <option [ngValue]="item.Id">{{ item.Name }}</option>
          }
        </select>
        @if (showError('scheduleId', 'min')) {
          <p class="error">Required</p>
        }
      </div>
    </div>

  </div>

</div>
